/**
 * @template {Record} T
 * @param {T[]} options
 * @param {string} idField
 * @param {(item: T, filter: string) => boolean} filterFn
 * @param {(item: T) => string} nameFn
 * @param {(item: T) => void} selectFn
 */
window.alpineSelect = function (options, idField, filterFn, nameFn, selectFn) {
    return {
        filter: '',
        show: false,
        selected: null,
        focusedOptionIndex: null,
        options,
        idField,
        close () {
            this.show = false
            this.filter = this.selectedName()
            this.focusedOptionIndex = this.selected
                ? this.focusedOptionIndex
                : null
        },
        open () {
            this.show = true
            this.filter = ''
        },
        toggle () {
            if (this.show) {
                this.close()
            } else {
                this.open()
            }
        },
        isOpen () { return this.show === true },
        selectedName () {
            return this.selected ? nameFn(this.selected) : this.filter
        },
        classOption (id, index) {
            const isSelected = this.selected
                ? (id === this.selected[this.idField])
                : false
            const isFocused = (index === this.focusedOptionIndex)
            return {
                'cursor-pointer w-full border-gray-100 border-b hover:bg-blue-50': true,
                'bg-blue-100': isSelected,
                'bg-blue-50': isFocused,
            }
        },
        /**
         * @returns {T[]}
         */
        filteredOptions () {
            return this.options
                ? this.options.filter(option => filterFn(option, this.filter))
                : []
        },
        onOptionClick (index) {
            this.focusedOptionIndex = index
            this.selectOption()
        },
        selectOption () {
            if (!this.isOpen()) {
                return
            }
            this.focusedOptionIndex = this.focusedOptionIndex ?? 0
            const selected = this.filteredOptions()[this.focusedOptionIndex]
            if (this.selected && this.selected[this.idField] === selected[this.idField]) {
                this.filter = ''
                this.selected = null
            } else {
                this.selected = selected
                this.filter = this.selectedName()
                selectFn(selected)
            }
            this.close()
        },
        focusPrevOption () {
            if (!this.isOpen()) {
                return
            }
            const optionsNum = Object.keys(this.filteredOptions()).length - 1
            if (this.focusedOptionIndex > 0 && this.focusedOptionIndex <=
                optionsNum) {
                this.focusedOptionIndex--
            } else if (this.focusedOptionIndex === 0) {
                this.focusedOptionIndex = optionsNum
            }
        },
        focusNextOption () {
            const optionsNum = Object.keys(this.filteredOptions()).length - 1
            if (!this.isOpen()) {
                this.open()
            }
            if (this.focusedOptionIndex == null || this.focusedOptionIndex ===
                optionsNum) {
                this.focusedOptionIndex = 0
            } else if (this.focusedOptionIndex >= 0 && this.focusedOptionIndex <
                optionsNum) {
                this.focusedOptionIndex++
            }
        },
    }

}
